import { expensesApi } from '../api/expensesApi'

export const getExpenses = async () => {
  try {
    const {
      data: { expenses },
    } = await expensesApi.getExpenses()
    return expenses
  } catch (error) {
    console.error(`Error fetching expenses: `, error)
    throw error
  }
}
